// 后台菜单栏
const sideOptions = [
  {
    title: "系统管理",
    key: "system",
    icon: "setting",
    child: [
      { title: "用户管理", key: "sysUser", toRouter: "/back/system/user" },
      { title: "角色管理", key: "sysRole", toRouter: "/back/system/role" },
      { title: "组织管理", key: "sysTissue", toRouter: "/back/system/tissue" },
      { title: "菜单管理", key: "sysMenu", toRouter: "/back/system/menu" },
    ],
  },
  {
    title: "内容管理",
    key: "content",
    icon: "setting",
    child: [
      { title: "文章管理", key: "conEssay", toRouter: "/back/content/essay" },
    ],
  },
];
// 设置这种格式保证点击菜单栏能被选中
const nameMap = {
  sysUser: ["system", "sysUser"],
  sysRole: ["system", "sysRole"],
  sysTissue: ["system", "sysTissue"],
  sysMenu: ["system", "sysMenu"],
  conEssay: ["content", "conEssay"],
};

nameMap.system = nameMap.sysUser;
nameMap.content = nameMap.conEssay;

// 在主页面中添加子页面(添加,编辑页面) 防止刷新后菜单栏选中错误
const childMap = [
  {
    fName: "sysUser", // 父页面的key值
    child: ["system"], // 子页面的key值
  },
  {
    fName: "conEssay", // 父页面的key值
    child: ["content"], // 子页面的key值
  },
];

module.exports = {
  sideOptions,
  // 映射表
  nameMap,
  childMap,
};
